import React, { useEffect } from "react";
import "./demo.css";

const Demo = () => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://snack.expo.io/embed.js";
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div
      data-snack-id="HJTrpVpWI"
      data-snack-platform="android"
      data-snack-preview="true"
      data-snack-theme="dark"
      className="demo"
    ></div>
  );
};

export default Demo;
